import { useSelector } from 'react-redux'
import props from '../../../../redux/props'
import LargeContainer from '../../../UI/Container/LargeContainer'
import SimpleList from '../../../UI/SimpleList/SimpleList'
import Upsert from '../Upsert/Upsert'
import HeadlineSplit from '../../../UI/Headline/Split'
import { NAWSurvey } from '../../../../types/NAW/Survey'
import Item from './Item'
import useLoadNAWSurveys from '../../../hooks/NAW/useLoadNAWSurveys'
import { frontendDomain } from '../../../../utility'
import Copy from './Copy'
import ContactImport from './ContactImport'
import { useState } from 'react'
import sortingMechanism, { SortDirection, SortProp } from './sortingMechanism'

const List = () => {
  const t = useSelector((s) => s[props.TRANSLATION])
  const [surveys, pull] = useLoadNAWSurveys()
  const [sortProp, setSortProp] = useState(null)
  const [sortDirection, setSortDirection] = useState<SortDirection>(SortDirection.asc)

  const filter = (search: string) => (item: NAWSurvey) => {
    return item.name.toLowerCase().includes(search.toLowerCase())
  }

  const setSort = (newSortProp: SortProp) => () => {
    if (sortProp === newSortProp) {
      setSortDirection(sortDirection === SortDirection.asc ? SortDirection.desc : SortDirection.asc)
    } else {
      setSortProp(newSortProp)
      setSortDirection(SortDirection.asc)
    }
  }

  const Header = () => (
    <div className="flex w-full items-center gap-2">
      <div onClick={setSort(SortProp.name)} className="cursor-pointer w-6/12 font-bold text-blue">
        {t.naw.survey.attributes.name}
      </div>
      <div onClick={setSort(SortProp.lastInteraction)} className="cursor-pointer w-2/12 font-bold">
        {t.naw.survey.list.lastInteraction}
      </div>
      <div onClick={setSort(SortProp.furthestStep)} className="cursor-pointer w-2/12 font-bold">
        {t.naw.survey.list.furthestStep.label}
      </div>
      <div className="w-2/12"></div>
    </div>
  )

  const sorting = (data: NAWSurvey[]) => sortingMechanism(sortProp, sortDirection, data, t)

  return (
    <LargeContainer>
      <div className="flex flex-col gap-1 pt-2 pb-10 mt-10">
        <HeadlineSplit suffix={t.naw.survey.list.titleSplit.suffix} subline={t.naw.survey.list.titleSplit.subline} />
        <div className="flex gap-10">
          <div className="mt-5 p-2 shadow-sm bg-lightGray md:w-1/2 lg:w-1/3 flex flex-col gap-2">
            <div className="font-bold">{t.naw.survey.list.publicLink}</div>
            <div className="text-sm ">{t.naw.survey.list.publicLinkHint}</div>
            <Copy text={`${frontendDomain}/public/naw`} />
          </div>
          <div className="mt-5 p-2 shadow-sm bg-lightGray md:w-1/2 lg:w-1/3 flex flex-col gap-2">
            <div className="font-bold">{t.naw.survey.list.contactImport}</div>
            <div className="text-sm ">{t.naw.survey.list.contactImportHint}</div>
            <ContactImport callback={pull} />
          </div>
        </div>
        <SimpleList sorting={sorting} data={surveys} filter={filter} Component={Item} pull={pull} Upsert={Upsert} Header={Header} />
      </div>
    </LargeContainer>
  )
}

export default List
